import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import { EditedUserData, UserEditionPayload } from './user-edition.types';

// deprecated service ref.: updateUserService_DEPRECATED

// ✅ Implementado
export async function updateUserDataService({ query: rawQuery, body }: UserEditionPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.put<EditedUserData>(ENDPOINT.USERS, { query, body });

  return {
    response,
    summary: data,
  };
}
